<template>
	<div>
		<div>
			<div style="font-size:15px;font-weight:700;color:black">合同信息</div>
			<el-divider></el-divider>
			<div style="height:30px; font-size:15px;font-weight:700">组织架构：{{$globals.group_name + '/' + $parent.$parent.ruleForm.range}}</div>
			<div style="display:flex;font-size:15px;font-weight:700">
				<div style="flex:column;width:50%">
					<div style="height:30px">身份证：{{$parent.$parent.ruleForm.staff_card}}</div>
					<div style="height:30px">
						起止时间：{{$parent.$parent.ruleForm.start_date}}-{{$parent.$parent.ruleForm.end_date}}</div>
				</div>
				<div style="">
					<div style="height:30px">姓名：{{$parent.$parent.ruleForm.staff_name}}</div>
					<div style="height:30px">手机号：{{$parent.$parent.ruleForm.staff_telephone}}</div>
					<div style="height:30px">岗位：{{$parent.$parent.ruleForm.post_name}}</div>
				</div>
			</div>
			<div style="font-size:15px;font-weight:700;margin-top:20px">附件：{{$parent.$parent.ruleForm.staff_card}}</div>

			<div style="font-size:15px;font-weight:700;color:black;margin-top:80px">合同签订信息</div>
			<el-divider></el-divider>
			<div>
				<div style="font-size:15px;font-weight:700">合同订单附件：</div>
				<div>
					<el-upload class="upload-demo" :action="action" :on-preview="handlePreview"
						:on-remove="handleRemove" :on-success="uploadFujian" :before-remove="beforeRemove" multiple
						:on-exceed="c" :file-list="fileList">
						<img src="../../../assets/上传附件.png" style="margin-top:20px;height:25px">
					</el-upload>
				</div>
			</div>
			<el-button type="goon" style="margin:20px 0 0 220px" @click="saveFj">保存</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				ruleForm: {
					id: "",
					staff_id: "",
					company_name: "",
					city_name: "",
					modular_name: "",
					project_name: "",
					post_name: "",
					staff_name: "",
					staff_card: "",
					staff_telephone: "",
					start_date: "",
					end_date: "",
					is_signContract: "",
				},
				action: this.$globals.http + "file/upload",
				fileList: [],
				enclosureList: [],
			}
		},
		methods: {
			uploadFujian(response, file, fileList) {
				var that = this;
				debugger
				if (response.code == "200") {
					this.enclosureList.push({
						"enclosure_url": response.data.fileUrl,
						"enclosure_name": response.data.fileName,
						"enclosure_size": response.data.fileSize
					})
				} else {
					that.enclosure_url = response.data.response.data;
					that.enclosure_name = response.data.fileName;
					that.enclosure_size = response.data.fileSize;
				}
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			async saveFj() {
				var id = this.$parent.$parent.ruleForm.id;
				var url = "StaffEnclosure/insert";
				var record = {
					data_name: "附件",
					data_grouping: "",
					staff_id: id,
					enclosure_type: "员工合同",
					enclosureList: this.enclosureList,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.$parent.$parent.Find();
						this.$parent.$parent.dialogVisible = false;

					} else {
						this.$message.warning(data);
					}
				}
			}
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Yghtqd_qian.vue?3381ddb0